import { render } from "./Internal.vue?vue&type=template&id=28ed0e9a"
import script from "./Internal.vue?vue&type=script&lang=js"
export * from "./Internal.vue?vue&type=script&lang=js"
script.render = render

export default script